import React from 'react';
import styled from '@emotion/styled';

import { getColor } from './UICommon';

interface StyleProps {
  borderRadius: boolean;
}

const RootDiv = styled.div`
  color: ${getColor('WHITE')};
  height: 228px;
  background: linear-gradient(91.86deg, #6b65e7 0%, #9e65e7 100%);
  padding: 48px 32px;
  text-align: center;
  margin-bottom: 32px;
  display: block;
  align-items: flex-end;
  border-radius: ${(props: StyleProps) => (props.borderRadius ? '8px' : 0)};
`;

const H3 = styled.p`
  font-size: 64px;
  font-weight: 300;
  height: 64px;
  line-height: initial;
`;

const P = styled.p`
  width: 222px;
  margin: 0 auto;
  font-size: 20px;
  margin-top: 8px;
  line-height: 30px;
`;

export interface StatisticSectionProps {
  percentageNumber: string;
  description: string;
  borderRadius?: boolean;
}

export const StatisticSection = ({ percentageNumber, description, borderRadius = true }: StatisticSectionProps) => {
  return (
    <RootDiv borderRadius={borderRadius}>
      <H3>{percentageNumber}</H3>
      <P className="description">{description}</P>
    </RootDiv>
  );
};
